var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "mb14 normal-page",
          attrs: { "body-style": { padding: "20px 20px 0 20px" } },
        },
        [
          _c("oaFromBox", {
            attrs: {
              search: _vm.search,
              total: _vm.total,
              isAddBtn: false,
              isViewSearch: false,
              title: _vm.$route.meta.title,
            },
            on: { confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
            },
            [
              _vm.tableData.length == 0
                ? _c("div", { staticClass: "defaultPage" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        alt: "",
                        src: require("../../../assets/images/defd.png"),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [
                      _vm._v(" 暂无发票数据"),
                    ]),
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: { width: "100%", overflow: "auto" },
                      style: { height: _vm.tableHeight },
                    },
                    _vm._l(_vm.tableData, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "table-box" },
                        [
                          _c("div", [
                            _c("div", { staticClass: "header" }, [
                              _c("div", { staticClass: "header-left" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm._f("titleTypeFn")(item.types)) +
                                    "·" +
                                    _vm._s(
                                      item.collect_type == "mail"
                                        ? "电子"
                                        : "纸质"
                                    ) +
                                    "\n                "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "table-add",
                                    class: _vm._f("bgcFn")(item.status),
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("statusTypeFn")(item.status)
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "left" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: ["fd:invoice:check"],
                                          expression: "['fd:invoice:check']",
                                        },
                                      ],
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleCheck(item)
                                        },
                                      },
                                    },
                                    [_vm._v("查看 ")]
                                  ),
                                  _vm._v(" "),
                                  item.status === 5 && item.num
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDown(item)
                                            },
                                          },
                                        },
                                        [_vm._v("下载\n                ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.status === 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleInvoicUri(item)
                                            },
                                          },
                                        },
                                        [_vm._v("在线开票 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.status === 1
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: ["fd:invoice:edit"],
                                              expression: "['fd:invoice:edit']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleInvoicing(item)
                                            },
                                          },
                                        },
                                        [_vm._v("录入发票\n                ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.status == 5
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: ["fd:invoice:void"],
                                              expression: "['fd:invoice:void']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.voidFn(item)
                                            },
                                          },
                                        },
                                        [_vm._v("作废\n                ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            item.types == "3"
                              ? _c("div", { staticClass: "content main" }, [
                                  _c(
                                    "div",
                                    { staticClass: "left" },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "110px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "发票抬头：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.title,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [_vm._v(_vm._s(item.title))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "纳税人识别号：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.ident,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.ident || "--")
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "开票金额：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  class:
                                                    item.price == item.amount
                                                      ? ""
                                                      : "active",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.amount,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [_vm._v(_vm._s(item.amount))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "line" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "right" },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "110px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "客户名称：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.customer
                                                      ? item.customer
                                                          .customer_name
                                                      : "--"
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          item.collect_type == "mail"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "邮箱信息：",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pointer copy",
                                                      attrs: {
                                                        "data-clipboard-text":
                                                          item.collect_email,
                                                        title: "点击复制",
                                                      },
                                                      on: { click: _vm.copy },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.collect_email ||
                                                            "--"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "邮寄信息：",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pointer copy",
                                                      attrs: {
                                                        "data-clipboard-text":
                                                          item.collect_name +
                                                          " " +
                                                          item.collect_tel +
                                                          " " +
                                                          item.mail_address,
                                                        title: "点击复制",
                                                      },
                                                      on: { click: _vm.copy },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.collect_name
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            item.collect_tel
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            item.mail_address
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "申请人：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.card
                                                        ? item.card.name
                                                        : "--"
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "申请时间：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " + _vm._s(item.created_at)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "付款金额：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    item.price == item.amount
                                                      ? ""
                                                      : "active",
                                                },
                                                [_vm._v(_vm._s(item.price))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.types == "2"
                              ? _c("div", { staticClass: "content main" }, [
                                  _c(
                                    "div",
                                    { staticClass: "left" },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "110px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "发票抬头：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.title,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [_vm._v(_vm._s(item.title))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "纳税人识别号：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.ident,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.ident || "--")
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "开票金额：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  class:
                                                    item.price == item.amount
                                                      ? ""
                                                      : "active",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.amount,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [_vm._v(_vm._s(item.amount))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "line" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "right" },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "110px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "客户名称：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.customer
                                                      ? item.customer
                                                          .customer_name
                                                      : "--"
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          item.collect_type == "mail"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "邮箱信息：",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pointer copy",
                                                      attrs: {
                                                        "data-clipboard-text":
                                                          item.collect_email,
                                                        title: "点击复制",
                                                      },
                                                      on: { click: _vm.copy },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.collect_email ||
                                                            "--"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "邮寄信息：",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pointer copy",
                                                      attrs: {
                                                        "data-clipboard-text":
                                                          item.collect_name +
                                                          " " +
                                                          item.collect_tel +
                                                          " " +
                                                          item.mail_address,
                                                        title: "点击复制",
                                                      },
                                                      on: { click: _vm.copy },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.collect_name
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            item.collect_tel
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            item.mail_address
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "申请人：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.card
                                                        ? item.card.name
                                                        : "--"
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "申请时间：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " + _vm._s(item.created_at)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "付款金额：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    item.price == item.amount
                                                      ? ""
                                                      : "active",
                                                },
                                                [_vm._v(_vm._s(item.price))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.types == "1"
                              ? _c("div", { staticClass: "content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "left" },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "110px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "发票抬头：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.title,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.title) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "开票金额：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer copy",
                                                  class:
                                                    item.price == item.amount
                                                      ? ""
                                                      : "active",
                                                  attrs: {
                                                    "data-clipboard-text":
                                                      item.amount,
                                                    title: "点击复制",
                                                  },
                                                  on: { click: _vm.copy },
                                                },
                                                [_vm._v(_vm._s(item.amount))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "line" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "right" },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "110px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "客户名称：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.customer
                                                      ? item.customer
                                                          .customer_name
                                                      : "--"
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          item.collect_type == "mail"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "邮箱信息：",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pointer copy",
                                                      attrs: {
                                                        "data-clipboard-text":
                                                          item.collect_email,
                                                        title: "点击复制",
                                                      },
                                                      on: { click: _vm.copy },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.collect_email ||
                                                            "--"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "邮寄信息：",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "pointer copy",
                                                      attrs: {
                                                        "data-clipboard-text":
                                                          item.collect_name +
                                                          " " +
                                                          item.collect_tel +
                                                          " " +
                                                          item.mail_address,
                                                        title: "点击复制",
                                                      },
                                                      on: { click: _vm.copy },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.collect_name
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            item.collect_tel
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            item.mail_address
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "申请人：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.card
                                                        ? item.card.name
                                                        : "--"
                                                    )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "申请时间：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " + _vm._s(item.created_at)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "付款金额：",
                                                prop: "name",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    item.price == item.amount
                                                      ? ""
                                                      : "active",
                                                },
                                                [_vm._v(_vm._s(item.price))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "page-size": _vm.where.limit,
                      "current-page": _vm.where.page,
                      "page-sizes": [15, 20, 30],
                      layout: "total, sizes,prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("examine-dialog", {
        ref: "examineDialog",
        attrs: { config: _vm.config },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("invoice-details", {
        ref: "invoiceDetailsView",
        attrs: { "form-data": _vm.invoiceData },
      }),
      _vm._v(" "),
      _c("invoice-view", {
        ref: "invoiceView",
        attrs: { "form-data": _vm.invoiceData },
      }),
      _vm._v(" "),
      _c("invoicingDialog", {
        ref: "invoicingDialog",
        attrs: { config: _vm.invoicingDialog },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toVoid" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogFormVisible,
                title: "作废",
                width: "540px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "mt20" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "voidData",
                      staticClass: "from",
                      attrs: { model: _vm.voidDataForm },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: [
                              {
                                required: true,
                                message: "请填写作废原因",
                                trigger: "blur",
                              },
                            ],
                            label: "作废原因：",
                            "label-width": "100px",
                            prop: "voidData",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写原因",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.voidDataForm.voidData,
                              callback: function ($$v) {
                                _vm.$set(_vm.voidDataForm, "voidData", $$v)
                              },
                              expression: "voidDataForm.voidData",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "footer" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  _vm.dialogFormVisible = false
                                },
                              },
                            },
                            [_vm._v("取 消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.submit },
                            },
                            [_vm._v("确 定")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "headerbtn",
          attrs: {
            top: "7vh",
            visible: _vm.dialogInvoiceVisible,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogInvoiceVisible = $event
            },
          },
        },
        [
          _vm.invoiceUri
            ? _c("iframe", {
                attrs: {
                  src: _vm.invoiceUri,
                  frameborder: "0",
                  height: "650",
                  width: "100%",
                },
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }